import { logger } from '@/tools/logger';

import { resolveStateURI } from '@/tools/storeURIHandler';

/**
 * inits elementVars to show values from the store
 * at the moment only on rendering the value is updated
 */
export default {
	init() {
		logger.log('#variable Init store Variables');
		[...this.$el.querySelectorAll('var[src]')].forEach(($storeVar) => {
			const storeVarID = $storeVar.getAttribute('src').trim();
			logger.log('#variable storage:', storeVarID);

			const value = this.$store.state.dataSourceCFG.variableStorage.find((item) => {
				return item.id == storeVarID ? item : false;
			}).storeURL;

			logger.log('#variable value:', value);

			const storePath = 'store://' + value.trim();
			logger.log('#variable Init store variable Path: ', storePath);
			// TODO: update values on store changes
			$storeVar.innerHTML = resolveStateURI(storePath, this.$store);
			logger.log('#variable Init store variable value: ', resolveStateURI(storePath, this.$store));
			// $storeVar.removeAttribute('src'); // empty links to prefent ugly url dragging
			$storeVar.dataset.url = storePath;
			this.contentUIStoreWatchers.push(
				this.$store.watch(
					() => resolveStateURI(storePath, this.$store),
					(value) => {
						$storeVar.innerHTML = value;
					}
				)
			);
		});
	},
};
